<script setup lang="ts">
  import FlowPathInput from '@/components/form/FlowPathInput.vue'
  import {
    FormFieldContainer,
    DropDown,
    InputField,
    LICENSE_PLATE_COUNTRIES,
    SwitchButton,
    type LicensePlateCountry,
    type LicensePlateElement,
  } from '@logistiek-zonder-papier/lzp-library'
  import { reactive } from 'vue'

  const field = defineModel<LicensePlateElement>({ required: true })
  const touched = reactive({
    storeLocation: false,
  })

  function validateDto() {
    return touched.storeLocation &&
      field.value?.type === 'licensePlate' &&
      !field.value?.storeLocation?.trim()
      ? 'DTO Target Path is required'
      : null
  }
</script>

<template>
  <div class="field-config-container">
    <FormFieldContainer label="Label">
      <FlowPathInput
        placeholder="e.g. ${customer.name}"
        hint="Field label. Supports ${...} interpolation."
        v-model="field.label"
        :optional="true"
        type="text"
        :validate-paths="true"
      />
    </FormFieldContainer>

    <FormFieldContainer label="Placeholder">
      <FlowPathInput
        placeholder="Placeholder text"
        hint="Grey hint inside the field. Supports ${...} interpolation."
        v-model="field.placeholder"
        :optional="true"
        type="text"
        :validate-paths="true"
      />
    </FormFieldContainer>

    <FormFieldContainer label="Default value">
      <FlowPathInput
        placeholder="Initial value"
        v-model="field.defaultValue"
        :optional="true"
        :validate-paths="true"
      />
    </FormFieldContainer>

    <DropDown
      :required="true"
      label="Auto Format Land"
      :modelValue="{ value: field.countryFormatting }"
      idKey="value"
      :data="
        LICENSE_PLATE_COUNTRIES.map(value => ({
          value,
        }))
      "
      @update:modelValue="
        (value: { value: LicensePlateCountry }) => (field.countryFormatting = value.value)
      "
    >
      <template #item="{ item }">{{ item.value ?? 'Selecteer een optie' }}</template>
    </DropDown>

    <DropDown
      :required="true"
      label="Land Validatie"
      :modelValue="{ value: field.countryValidation }"
      idKey="value"
      :data="
        LICENSE_PLATE_COUNTRIES.map(value => ({
          value,
        }))
      "
      @update:modelValue="
        (value: { value: LicensePlateCountry }) => (field.countryValidation = value.value)
      "
    >
      <template #item="{ item }">{{ item.value ?? 'Selecteer een optie' }}</template>
    </DropDown>

    <FormFieldContainer label="Store Location" :error="validateDto()">
      <InputField
        placeholder="x.path.to.location"
        hint="Target path url."
        v-model="field.storeLocation"
        type="text"
        @blur="touched.storeLocation = true"
      />
    </FormFieldContainer>

    <FormFieldContainer label="Required">
      <SwitchButton v-model="field.required" />
    </FormFieldContainer>

    <FormFieldContainer label="Error message">
      <FlowPathInput
        placeholder="Error message under the field"
        v-model="field.error"
        :optional="true"
        :validate-paths="true"
      />
    </FormFieldContainer>
  </div>
</template>

<style scoped>
  .field-config-container {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .two-columns {
    display: flex;
    gap: 0.75rem;
  }

  .row {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
</style>
